var React = require('react');

function BalloonTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M76 38.5C38 38.5 29.6798 49.7753 0 57C0 57 20 22 17 4.50001C14 -13 114 38.5 76 38.5Z","fill":"white"}));
}

BalloonTriangle.defaultProps = {"width":"85","height":"57","viewBox":"0 0 85 57","fill":"none"};

module.exports = BalloonTriangle;

BalloonTriangle.default = BalloonTriangle;
